import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Services.css';

const CodeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
    <line x1="13" y1="4" x2="11" y2="20"/>
  </svg>
);
const PenIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="3" y1="9" x2="21" y2="9"/>
    <line x1="9" y1="21" x2="9" y2="9"/>
  </svg>
);
const TrendIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 7l-7.5 7.5-4-4L1 21"/>
    <path d="M17 7h6v6"/>
    <rect x="3" y="3" width="7" height="5" rx="1"/>
  </svg>
);
const CheckIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const CubeIcon = () => (
  <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
    <line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);

import { usePortfolio } from '../context/PortfolioContext';

const faqs = [
  { q: 'How long does a typical project take?', a: 'Landing pages usually take 1–2 weeks, while larger website or app projects can take 3–8 weeks depending on scope.' },
  { q: 'Do you provide support after delivery?', a: 'Yes. I provide post-launch support for fixes, updates, and performance improvements based on your project needs.' },
  { q: 'How do we communicate during the project?', a: 'We can coordinate through WhatsApp, email, and scheduled calls with regular progress updates and milestone reviews.' },
  { q: 'What are your payment terms?', a: 'For most projects I work with an upfront advance and the remaining payment on agreed milestones or completion.' },
];

export default function Services() {
  const navigate = useNavigate();
  const { data, loading } = usePortfolio();
  const [openFaq, setOpenFaq] = useState(null);

  if (loading || !data) {
    return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-dark)', color: 'white' }}>Loading...</div>;
  }
  const { services } = data;

  return (
    <div className="services-page page-enter">
      <Navbar />

      {/* HERO */}
      <section className="services-hero">
        <div className="sv-container">
          <div className="services-hero-inner">
            <div className="services-hero-content">
              <span className="sv-badge">Talha Developments Services</span>
              <h1>Practical Solutions for<br /><span className="purple">Real Digital Growth</span></h1>
              <p>I help individuals and brands turn ideas into polished digital products through development, design, SEO, and visual content support.</p>
            </div>
            <div className="services-hero-icon">
              <CubeIcon />
            </div>
          </div>
        </div>
      </section>

      {/* SERVICE CARDS */}
      <section className="service-cards-section">
        <div className="sv-container">
          {services.map((svc, i) => {
            let IconComp = <CodeIcon />;
            if (svc.iconType === 'pen') IconComp = <PenIcon />;
            if (svc.iconType === 'trend') IconComp = <TrendIcon />;
            if (svc.iconType === 'users') IconComp = <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>;
            if (svc.iconType === 'cube') IconComp = <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>;
            if (svc.iconType === 'brand') IconComp = <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>;
            return (
            <div key={svc.title} className={`svc-card ${i % 2 === 1 ? 'reverse' : ''}`}>
              <div className="svc-main">
                <div className="svc-icon-wrap">
                  {IconComp}
                </div>
                <h2>{svc.title}</h2>
                <p className="svc-desc">{svc.desc}</p>
                <div className="svc-features">
                  {svc.features.map(f => (
                    <div key={f} className="svc-feature">
                      <span className="svc-check"><CheckIcon /></span>
                      {f}
                    </div>
                  ))}
                </div>
                <button className="btn-primary" onClick={() => navigate('/contact')}>Start a Project</button>
              </div>
              <div className={`svc-visual svc-visual-${svc.visual}`}>
                {svc.visual === 'web' && (
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="rgba(139,92,246,0.35)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2"/>
                    <line x1="8" y1="21" x2="16" y2="21"/>
                    <line x1="12" y1="17" x2="12" y2="21"/>
                    <polyline points="16 18 22 12 16 6"/>
                    <polyline points="8 6 2 12 8 18"/>
                  </svg>
                )}
                {svc.visual === 'app' && (
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="rgba(139,92,246,0.35)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                    <line x1="12" y1="18" x2="12.01" y2="18"/>
                  </svg>
                )}
                {svc.visual === 'shopify' && (
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="rgba(139,92,246,0.35)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                    <line x1="3" y1="6" x2="21" y2="6"/>
                    <path d="M16 10a4 4 0 01-8 0"/>
                  </svg>
                )}
                {svc.visual === 'marketing' && (
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="rgba(139,92,246,0.35)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21.21 15.89A10 10 0 118 2.83"/>
                    <path d="M22 12A10 10 0 0012 2v10z"/>
                  </svg>
                )}
                {svc.visual === 'design' && (
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="rgba(139,92,246,0.35)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                  </svg>
                )}
                {svc.visual === 'video' && (
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="rgba(139,92,246,0.35)" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="23 7 16 12 23 17 23 7"/>
                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                  </svg>
                )}
              </div>
            </div>
            );
          })}
        </div>
      </section>

      {/* FAQ */}
      <section className="faq-section">
        <div className="sv-container">
          <div className="section-header">
            <h2>Frequently Asked Questions</h2>
            <div className="section-divider" />
            <p>Common questions about how I work and what to expect.</p>
          </div>
          <div className="faq-list">
            {faqs.map((f, i) => (
              <div key={i} className={`faq-item ${openFaq === i ? 'open' : ''}`}>
                <button className="faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{f.q}</span>
                  <span className="faq-chevron">{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && <p className="faq-a">{f.a}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="sv-cta">
        <div className="sv-container" style={{ textAlign: 'center' }}>
          <h2>Ready to build something<br /><span className="purple">extraordinary?</span></h2>
          <p>Have a project idea? Let’s discuss your goals and build a solution that delivers real results.</p>
          <div className="sv-cta-btns">
            <button className="btn-primary" onClick={() => navigate('/contact')}>Book a Discovery Call</button>
            <button className="btn-outline" onClick={() => navigate('/projects')}>View My Work</button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
